import { Box, Link, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import React from 'react';
import { Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ButtonContainer, Wrapper, Container } from './styles';

export type ContentSectionProps = {
	title: string;
	exploreAllLink?: string;
	children: React.ReactElement;
};
export const ContentSection = (props: ContentSectionProps) => {
	const navigate = useNavigate();

	const { title, exploreAllLink, children } = props;

	return (
		<Wrapper>
			<Container maxWidth='xl'>
				<Grid container display='flex' alignItems='center' justifyContent='space-between' marginBottom={1}>
					<Grid item xs={8} md={6}>
						<Typography
							component='h2'
							sx={{
								fontSize: { xs: 18, md: 22 },
								fontWeight: 700,
								letterSpacing: '-0.01em',
								color: (theme) => theme.colors.text,
								whiteSpace: 'nowrap',
								overflow: 'hidden',
								textOverflow: 'ellipsis',
							}}
						>
							{title}
						</Typography>
					</Grid>
					{exploreAllLink && (
						<ButtonContainer item xs={3} md={6} display='flex' alignItems='center'>
							<Link
								href={exploreAllLink}
								onClick={() => navigate(exploreAllLink)}
								sx={{
									display: 'inline-flex',
									alignItems: 'center',
									gap: 0.5,
									fontSize: 14,
									fontWeight: 600,
									color: (theme) => theme.colors.text,
									textDecoration: 'none',
									transition: 'color 0.15s ease',
									'&:hover': { color: (theme) => theme.colors.brand },
								}}
							>
								<Trans i18nKey='components.contentSection.exploreAll' />
							</Link>
						</ButtonContainer>
					)}
				</Grid>
			</Container>
			<Box display='flex' width='100%'>
				{children}
			</Box>
		</Wrapper>
	);
};
